import { ComponentProps, forwardRef } from "react";
import { FieldErrors, FieldValues } from "react-hook-form";
import { FormInputLayout } from "./FormInputLayot";
import CustomInput  from "../CustomInput";

type FormInputProps = {
  name: string;
  label?: string;
  error?: FieldErrors<FieldValues> | string;
  showError?: boolean;
  classNameForm?: string;
  clearable?: boolean;
} & ComponentProps<"input">;

/**
 * @component
 * Компонент формы поля
 * @description
 * Форма с label и отображением ошибки
 */

export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  (
    { name, label, error, showError = true, classNameForm, id, clearable, ...props },
    ref
  ) => {
    const errorState = showError && error;
    return (
      <FormInputLayout
        name={name}
        id={id}
        label={label}
        classNameForm={classNameForm}
        error={error}
        showError={showError}
      >
        <CustomInput 
          {...props} 
          ref={ref} 
          name={name} 
          id={id ? id : name} 
          clearable={clearable}
          hasError={errorState}
        />
      </FormInputLayout>
    );
  }
);

FormInput.displayName = "FormInput";